<script>
export default {
  name: 'AccordionPlusIcon',
  props: {
    color: {
      type: String,
      default: 'black'
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    active: false
  }),
  computed: {
    styles () {
      return {
        container: {
          '--scale': this.scale
        },
        hstick: {
          '--rotation': this.active ? '-180deg' : '0deg',
          '--background-color': this.color
        },
        vstick: {
          '--opacity': this.active ? 0 : 1,
          '--rotation': this.active ? '-180deg' : '0deg',
          '--background-color': this.color
        }
      }
    }
  },
  methods: {
    animate () {
      this.active = !this.active
    }
  }
}
</script>

<template>
  <div
    class="accordion-plus-icon-container"
    :style="styles.container"
  >
    <div
      class="horizontal-stick"
      :style="styles.hstick"
    />
    <div
      class="vertical-stick"
      :style="styles.vstick"
    />
  </div>
</template>

<style lang="scss" scoped>
.accordion-plus-icon-container {
  height:calc(30px * var(--scale));
  width: calc(30px * var(--scale));
  position: relative;
  .horizontal-stick {
    position: absolute;
    top: calc(12px * var(--scale));
    width: calc(30px * var(--scale));
    height: calc(6px * var(--scale));
    border-radius: calc(3px * var(--scale));
    background-color: var(--background-color);
    transform: rotateZ(var(--rotation));
    transition: transform 300ms ease-in-out;
  }
  .vertical-stick {
    position: absolute;
    left: calc(12px * var(--scale));
    width: calc(6px * var(--scale));
    height: calc(30px * var(--scale));
    border-radius: calc(3px * var(--scale));
    background-color: var(--background-color);
    transform: rotateZ(var(--rotation));
    opacity: var(--opacity);
    transition: transform 300ms ease-in-out, opacity 150ms linear;
  }
}
</style>
